export default __webpack_public_path__ + "static/media/sbo-img.cc2e9163.webp";